import clsx from "clsx";
import { forwardRef } from "react";

export type LoadingProps = {
  size?: "sm" | "md" | "lg";
  variant?: "default" | "light";
  className?: string;
};

const styles = {
  base: "inline-block",
  size: {
    sm: "w-4 h-4",
    md: "w-6 h-6",
    lg: "w-8 h-8",
  },
  variant: {
    default: "text-theme-accent",
    light: "text-white/80",
  },
  innerRing: "origin-center animate-spin",
};

export const Loading = forwardRef<SVGSVGElement, LoadingProps>(
  ({ size = "md", className, variant = "default" }, ref) => {
    return (
      <svg
        role="status"
        className={clsx([
          styles.base,
          styles.size[size],
          styles.variant[variant],
          className,
        ])}
        ref={ref}
        viewBox="0 0 24 24"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          className="opacity-20"
        />
        <g className={styles.innerRing}>
          <circle
            cx="12"
            cy="12"
            r="10"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeDasharray="32 20"
            strokeLinecap="round"
          />
        </g>
      </svg>
    );
  },
);
